import { uuid } from '~/utilities/uuid';

export default function (): string {
  return !!window?.crypto && !!crypto?.randomUUID
    ? crypto?.randomUUID()
    : uuid();
}
